const doc = [({"da":({"js":({"admin":({"emails":({"admin_confirm_button":({"the_email_was_confirmed":"Emailen blev bekræftet."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;